// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatEmptyState-modulecontent__mBkpd";
var _2 = "GretaAIChatEmptyState-moduleprompts__VwxbH";
var _3 = "GretaAIChatEmptyState-moduleroot__BUcGQ";
export { _1 as "content", _2 as "prompts", _3 as "root" }
